import * as ga from './ga';

const sendSegment = (event, options) => {
    if (event === 'track') {
        console.log(options.name);
        ga.event({
            action: options.name,
            params: options.data,
        });
    }
};

const sendLog = (log = '', context = {}) => {
    // const datadog = typeof window !== 'undefined' && window.DD_RUM;
    // if (datadog && typeof log === 'string') {
    //     datadog.addUserAction(log, context);
    // }
    console.log(log);
    ga.event({
        action: log,
        params: context,
    });
};

export {sendLog, sendSegment};
export default sendSegment;